/**
 * ErrorTitleEnum
 */
export enum ErrorTitle {
  DECLINE_TITTLE = "declineTransaction.declineTitle",
  CASH_TITTLE = "declineTransaction.cashTitle",
  TREE_D_SECURE = "declineTransaction.errorThreeDSecureTitle",
}
